import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { env } from './env';

const clients = new Map<string, SupabaseClient>();

/**
 * One client per studio: the owner session is stored under a studio-specific
 * key, so signing in to one studio's cabinet never leaks into another's.
 */
export function supabaseFor(slug: string): SupabaseClient {
  let c = clients.get(slug);
  if (!c) {
    c = createClient(env.supabaseUrl, env.supabaseAnonKey || 'anon', {
      auth: {
        storageKey: `sgx-auth-${slug}`,
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: false,
      },
    });
    clients.set(slug, c);
  }
  return c;
}

/** Public URL of an object in the tenant-media bucket (storage:<path> from the DB). */
export function mediaUrl(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  if (url.startsWith('storage:')) {
    return `${env.supabaseUrl}/storage/v1/object/public/tenant-media/${url.slice('storage:'.length)}`;
  }
  return url;
}
